import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { MethodInterface } from '../+models';

export const METHOD_SERVICE_TOKEN = new InjectionToken('MethodService');

export interface MethodServiceInterface {
  getAllForUser(userId: number): Observable<MethodInterface[]>;
  getAllowedMethodIds(userId: number): Observable<number[]>;
  getMethods$(
    searchTerm?: string,
    filters?: { [key: string]: string | number[] | number },
    pagination?: { from?: any; amount?: any },
    columns?: string[],
    sorting?: { [key: string]: 'asc' | 'desc' }
  ): Observable<{ results: MethodInterface[]; count: number }>;
  createMethod(method: MethodInterface): Observable<MethodInterface>;
  updateMethod(method: MethodInterface): Observable<MethodInterface>;
  deleteMethod(method: MethodInterface): Observable<boolean>;
}
